// extracted by mini-css-extract-plugin
module.exports = {"footer":"footer-module--footer--R2bpz","med":"footer-module--med--2Rvpl","sm":"footer-module--sm--HEhfs","border":"footer-module--border--tFde3"};